module.exports = __webpack_public_path__ + "static/media/level2.78572e01.png";